var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 4.58857H10.0405V6.30748L13.2999 3.15374L10.0405 0V1.71891H5.55664V4.58857Z",
    fill: "#82BA50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44337 9.14692H3.95945V10.8658L0.699951 7.71209L3.95945 4.55835V6.27726H8.44337V9.14692Z",
    fill: "#82BA50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/iconTransfer.f03d207853a490c8350648b0079e1d09.svg";
export { ForwardRef as ReactComponent };